export default {
    'UNAVAILABILITIES.TITLE': 'Aucune indisponibilité programmée',
    'UNAVAILABILITIES.ASIDE': 'Ajoutez votre première indisponibilité dans votre calendrier',
    'UNAVAILABILITIES.BUTTON.TEXT': 'Ajouter ma première indisponibilité',
};
